export default "__VITE_ASSET__Cy4yCbSQ__"